import React, { useState, useEffect } from 'react';
import { useQuoteStore } from 'src/hooks/quote';
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import useReduxState from 'src/hooks/useReduxState';

const QuoteInformation = () => {
    const { storageName: { QUOTE_CART_LIST } } = System
    const [__check] = useAxiosIndicatorCheck();
    const [{ submittedQuoteList }, { fetch_submitted_quote_list }, { }] = useQuoteStore();

    const [quoteHeaderData, setQuoteHeaderData] = useReduxState({}, 'setQuoteHeaderData')
    const [, setQuoteList] = useReduxState({}, 'QuoteCartList')

    const displayQuoteNumber = submittedQuoteList?.records && submittedQuoteList?.records[0]?.displayQuoteNumber + '-' + submittedQuoteList?.records[0]?.quoteRevisionNumber

    useEffect(() => {
        const quoteData = JSON.parse(sessionStorage.getItem(QUOTE_CART_LIST)) || {}
        setQuoteList(quoteData)

        const fetchHere = async () => {
            await fetch_submitted_quote_list({
                "pageNumber": 1,
                "pageSize": 1,
                "sortBy": '',
                "sortType": "",
                "quoteNumber": quoteData[0]?.quoteNumber,
                "requiredAddressDetails": true
            })
        }

        if (quoteData && quoteData?.length > 0) {
            fetchHere()
        }
    }, [])

    useEffect(() => {
        setQuoteHeaderData(submittedQuoteList?.records?.[0])
    }, [submittedQuoteList])

    return (
        <div className="checkout-total mb-3">
            {__check(['QUOTE_API_CALL']).status ?
                __check(['QUOTE_API_CALL']).render
                :
                <div className='p-15 '>
                    <div className="bs5 row mb-1">
                        <div className="col-12">
                            <div className="bs5 row m-0">
                                <div className="col-12 px-0 font-16 font-bold text-uppercase mb-2">
                                    Quote Information
                                </div>
                            </div>
                            <div className="bs5 row m-0">
                                <div className="col-4 px-0 ">
                                    <div className='font-bold'>Quote Number</div>
                                    <p>{displayQuoteNumber}</p>
                                </div>
                                <div className="col-4 px-0">
                                    <div className='font-bold'>Created On</div>
                                    <p>{Helper.dateFormatFromString(quoteHeaderData?.quoteRequestedDate)}</p>
                                </div>
                                <div className="col-4 px-0">
                                    <div className='font-bold'>Expires On</div>
                                    <p>{Helper.dateFormatFromString(quoteHeaderData?.quoteExpirationDate)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default QuoteInformation;